import { TThunkAction } from '../../types/redux';
import { ENewQuestionModalStep } from '../../types/newQuestion';
import { setNewQuestionFormStep } from './stepActionsTypes';
import { addQuestion } from '../../services/questions';
import { ELabel, ETrackingAction, trackQuestionFormAction } from './tracking';

export function addQuestionActions(): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const state = getState();
    const { httpApi } = context;
    const { newbuildingInfo, newQuestion } = state;

    const isFromErrorStep = newQuestion.step === ENewQuestionModalStep.Error;

    try {
      await addQuestion({
        httpApi,
        parameters: {
          newbuildingId: newbuildingInfo.newbuildingId,
          text: newQuestion.text,
          isAnonymous: newQuestion.isAnonymous,
          userName: newQuestion.name,
        },
      });

      dispatch(setNewQuestionFormStep(ENewQuestionModalStep.Success));
      trackQuestionFormAction(ETrackingAction.Success, isFromErrorStep ? ELabel.Error : ELabel.Form);
    } catch (e) {
      dispatch(setNewQuestionFormStep(ENewQuestionModalStep.Error));
      trackQuestionFormAction(ETrackingAction.Fail, isFromErrorStep ? ELabel.Error : ELabel.Form);
    }
  };
}
